import React from 'react';

export const useOverrides = <T>(defaults: T, overrides?: Partial<T>): T => {
	return React.useMemo(
		() => ({ ...defaults, ...overrides }),
		[defaults, overrides],
	);
};
